// extracted by mini-css-extract-plugin
export var customFontSize16 = "16px";
export var customFontSizeLg = "18px";
export var customFontSizeNormal = "14px";
export var customFontSizeSubtitle = "44px";
export var customFontSizeTitle = "56px";
export var customFontSizeXl = "22px";
export var customFontSizeXs = "12px";
export var customFontSizeXxl = "30px";
export var fontBold = "ProximaNovaBold";
export var fontRegular = "ProximaNovaRegular";
export var fontSemiBold = "ProximaNovaSemiBold";